(function (Drupal, once) {
  Drupal.behaviors.menuToggle = {
    attach: function (context) {
      once("menuToggle", ".main-menu li > span", context).forEach(
        function (span) {
          span.addEventListener("click", function () {
            const clickedLi = this.closest("li");
            const allLis = clickedLi.parentElement.querySelectorAll("li");

            allLis.forEach(function (li) {
              if (li !== clickedLi) {
                li.classList.remove("open");
              }
            });

            clickedLi.classList.toggle("open");
          });
        },
      );
    },
  };

  Drupal.behaviors.replaceAnyLabel = {
    attach(context) {
      once("replaceAnyLabel", "select", context).forEach(function (select) {
        const opt = select.querySelector('option[value=""]');
        if (opt && opt.textContent.trim() === "- Qualquer -") {
          opt.textContent = "Todos";
        }

        const placeholder = select
          .closest(".choices")
          ?.querySelector(".choices__item.choices__placeholder");
        if (placeholder && placeholder.textContent.trim() === "- Qualquer -") {
          placeholder.textContent = "Todos";
        }
      });
    },
  };

  /**
   * Close Site Studio modal when clicking the "Entendi" CTA link.
   */
  Drupal.behaviors.hslItemsListModalClose = {
    attach(context) {
      once(
        "hsl-items-list-modal-close",
        ".hsl-items-list-modal__modal__cta__link",
        context,
      ).forEach((cta) => {
        cta.addEventListener("click", (e) => {
          e.preventDefault();

          // Find the closest modal wrapper.
          const modal = cta.closest(".coh-modal, .a11y-modal");
          if (!modal) return;

          // Prefer the close button wrapper, fallback to any close target.
          const closeBtn =
            modal.querySelector(
              ".coh-modal-close-button[data-modal-close-btn]",
            ) || modal.querySelector("[data-modal-close-btn]");

          if (closeBtn) {
            closeBtn.click();
          }
        });
      });
    },
  };

  Drupal.behaviors.hslTempoEsperaModal = {
    attach(context) {
      // Abrir modal
      once(
        "hsl-tempo-espera-open",
        ".service-priority-open-modal",
        context,
      ).forEach((trigger) => {
        trigger.addEventListener("click", (e) => {
          e.preventDefault();

          const modal = document.querySelector(".hsl-tempo-espera--modal");
          if (!modal) return;

          modal.style.display = "block";
        });
      });

      // Fechar modal
      once(
        "hsl-tempo-espera-close",
        ".service-priority-close",
        context,
      ).forEach((closeBtn) => {
        closeBtn.addEventListener("click", (e) => {
          e.preventDefault();

          const modal = document.querySelector(".hsl-tempo-espera--modal");
          if (!modal) return;

          modal.style.display = "none";
        });
      });
    },
  };

  Drupal.behaviors.loadedPage = {
    attach(context) {
      const markLoaded = () => {
        document.body.classList.add("loaded");
      };

      once("loadedPage", "body", context).forEach(() => {
        if (
          document.readyState === "interactive" ||
          document.readyState === "complete"
        ) {
          markLoaded();
        } else {
          document.addEventListener("DOMContentLoaded", markLoaded, {
            once: true,
          });
        }

        window.addEventListener("load", markLoaded, { once: true });
      });
    },
  };

})(Drupal, once);
